export const getLastAutocompleteItem = () => {
    const autocompleteItems = document.querySelectorAll(
        ".autocompleteItem:last-of-type a",
    );
    const lastAutocompleteItem =
        autocompleteItems[autocompleteItems.length - 1];

    return lastAutocompleteItem instanceof HTMLElement
        ? lastAutocompleteItem
        : undefined;
};
